var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warning/Duotone"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66663 7.99999C1.66663 4.50219 4.50216 1.66666 7.99996 1.66666C11.4978 1.66666 14.3333 4.50219 14.3333 7.99999C14.3333 11.4978 11.4978 14.3333 7.99996 14.3333C4.50216 14.3333 1.66663 11.4978 1.66663 7.99999ZM7.99996 2.33332C4.87035 2.33332 2.33329 4.87038 2.33329 7.99999C2.33329 11.1296 4.87035 13.6667 7.99996 13.6667C11.1296 13.6667 13.6666 11.1296 13.6666 7.99999C13.6666 4.87038 11.1296 2.33332 7.99996 2.33332Z",
    fill: "#FFC72E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.99996 7.99999C1.99996 4.68628 4.68625 1.99999 7.99996 1.99999C11.3137 1.99999 14 4.68628 14 7.99999C14 11.3137 11.3137 14 7.99996 14C4.68625 14 1.99996 11.3137 1.99996 7.99999Z",
    fill: "#FFC72E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99996 4.16666C8.2761 4.16666 8.49996 4.39051 8.49996 4.66666V9.33332C8.49996 9.60947 8.2761 9.83332 7.99996 9.83332C7.72382 9.83332 7.49996 9.60947 7.49996 9.33332V4.66666C7.49996 4.39051 7.72382 4.16666 7.99996 4.16666Z",
    fill: "#614700"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33329 11C7.33329 10.6318 7.63177 10.3333 7.99996 10.3333C8.36815 10.3333 8.66669 10.6318 8.66669 11C8.66669 11.3682 8.36822 11.6667 8.00003 11.6667C7.63184 11.6667 7.33329 11.3682 7.33329 11Z",
    fill: "#614700"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoOrange);
export default __webpack_public_path__ + "static/media/info-orange.0e7ffa95d13755bb02bc119ac1dd0dce.svg";
export { ForwardRef as ReactComponent };